// extracted by mini-css-extract-plugin
export default {"codes":"PrismCode_codes__P8U1G","tools":"PrismCode_tools__CT+pu","svgStyle":"PrismCode_svgStyle__4sa-B","code":"PrismCode_code__XDVON","noCode":"PrismCode_noCode__veCUQ"};